export default __webpack_public_path__ + "static/media/StockIci-Logo.4b9ba917.png";